import { Button, Form, message, Modal, Space, Typography } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import Center from "../components/common/Center";
import Notification from "../components/common/Notification";
import TextArea from "../components/Form/TextArea";
import { deletePermanentItem, restoreItem } from "../store/actions/other/other.action";
import { wordCount, wordCounterRealTime } from "./wordCount";

export function RestoreOrDeleteModel({
	record,
	setIsModalVisible,
	isModalVisible,
	linkUrl,
	cancelMessage,
	selectItemsFor,
	findTypeValue,
}) {
	const { Text } = Typography;
	const [form] = Form.useForm();
	const dispatch = useDispatch();

	const [word, setWord] = useState(undefined);
	const showModal = () => {
		setIsModalVisible(true);
	};
	const handleCancel = () => {
		setIsModalVisible(false);
		message.error(cancelMessage);
	};

	const finish = async (values) => {
		try {
			const singleDataToRestore = selectItemsFor.find((data) => data.value === findTypeValue);
			await wordCount(values.reason, 10);
			await dispatch(restoreItem(record.id, singleDataToRestore.restoreUrl, values.reason));
			setIsModalVisible(false);
		} catch (err) {
			let errorMessage = err ? (err.message ? err.message : err) : "Something went wrong";
			return Notification("error", errorMessage, "", "topRight");
		}
	};

	return (
		<Space size="middle">
			<Text
				style={{ color: "#1890ff", cursor: "pointer" }}
				onClick={async () => {
					try {
						const singleDataToDelete = selectItemsFor.find((data) => data.value === findTypeValue);
						await dispatch(deletePermanentItem(record.id, singleDataToDelete.permanentDeleteUrl));
					} catch (err) {
						setIsModalVisible(false);
						let errorMessage = err ? (err.message ? err.message : err) : "Something went wrong";
						return Notification("error", errorMessage, "", "topRight");
					}
				}}
			>
				Permanent Delete
			</Text>
			{selectItemsFor.find((data) => data.value === findTypeValue)?.viewUrl ? (
				<NavLink
					to={`${selectItemsFor.find((data) => data.value === findTypeValue)?.viewUrl}/${
						record.id
					}?soft-delete=true`}
				>
					View
				</NavLink>
			) : null}
			<Text
				style={{ color: "#1890ff", cursor: "pointer" }}
				onClick={() => {
					showModal();
				}}
			>
				Restore
			</Text>
			<Modal visible={isModalVisible} onCancel={handleCancel} footer={null}>
				<Form
					form={form}
					name="basic"
					layout="vertical"
					onFinish={(values) => finish(values)}
					initialValues={{ reason: "" }}
				>
					<div style={{ minHeight: "120px" }}>
						<TextArea
							rules={[
								{
									required: true,
								},
								{
									message: "Reason required minimum 10 characters",
								},
							]}
							handleOnChange={(e) => setWord(e.target.value)}
							label="Reason"
							name="reason"
							extra={`Character count: ${wordCounterRealTime(word)} out of 10`}
						/>
					</div>
					<Form.Item style={{ marginTop: "20px" }}>
						<Center height="0px">
							<Space>
								<NavLink to={`${linkUrl}`}>
									<Button danger type="primary" onClick={handleCancel}>
										Cancel
									</Button>
								</NavLink>
								<Button type="primary" htmlType="submit">
									Restore
								</Button>
							</Space>
						</Center>
					</Form.Item>
				</Form>
			</Modal>
		</Space>
	);
}
